import { useState } from "react";
import { Formik } from "formik";
import { withRouter } from "react-router";
import { TextErrors } from "components/common/TextErrors";
import { FieldCustom } from "components/common/FieldCustom";
import { Button, Spinner } from "reactstrap";
import { getErrorMessages, getParameterValue } from "utils";
import { ShowSuccess } from "components/login/common/ShowError";
import landinLogo from "assets/images/logo-Landin.svg";
import { useMutation } from "react-query";
import { updatePassword } from "api/user/resetpassword";

const ResetPassFields = ({ history }) => {
  const [error, setError] = useState({ type: "", message: "" });
  const [message, setMessage] = useState("");

  const passwordReq = useMutation(
    ({ resetToken, password }) =>
      updatePassword({ ResetToken: resetToken }, { password }),
    {
      onSuccess: () => {
        setMessage("رمز عبور شما با موفقیت تغییر یافت.");
        setTimeout(() => history.push("/login"), 1000);
      },
      onError: error => {
        setError({
          type: "wrong",
          message: getErrorMessages(error),
        });
      },
    }
  );

  const resetPassword = (e, password) => {
    e.preventDefault();
    const resetToken = getParameterValue("ResetToken");
    passwordReq.mutate({ password, resetToken });
  };

  const validatePassword = value => {
    let error;
    if (!value) {
      error = "مقدار پسورد نباید خالی باشد";
    } else if (value.length < 8) {
      error = "پسورد نباید کمتر از 8 کاراکتر باشد";
    }
    return error;
  };

  const validateRePassword = (value, password) => {
    let error;
    if (value !== password) {
      error = "تکرار پسورد اشتباه است.";
    }
    return error;
  };

  return (
    <div className=" pt-3">
      <Formik
        initialValues={{ password: "", repassword: "" }}
        onSubmit={async values => {
          await new Promise(resolve => setTimeout(resolve, 500));
          alert(JSON.stringify(values, null, 2));
        }}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            //dirty,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
            getFieldProps,
            //handleReset
          } = props;
          return (
            <form onSubmit={handleSubmit} className="mb-5">
              <div className="forget-label mb-3 px-2">
                رمز عبور جدید خود را وارد کنید
              </div>
              <FieldCustom
                type="password"
                name={"password"}
                placeHolder={"رمز عبور"}
                onChange={handleChange}
                onBlur={handleBlur}
                validate={validatePassword}
                className={
                  touched.password
                    ? errors.password
                      ? "input-border-error"
                      : "input-border-green"
                    : "input-border-default"
                }
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.21"
                    height="22.029"
                    viewBox="0 0 18.21 22.029"
                  >
                    <g
                      id="password_icon"
                      data-name="password icon"
                      transform="translate(-965.481 -229.83)"
                    >
                      <path
                        id="Path_86"
                        data-name="Path 86"
                        d="M412.777,500.6v-3.731a5.807,5.807,0,0,0-1.932-4.505,5.2,5.2,0,0,0-1-.649,6.123,6.123,0,0,0-6.475.868,7.188,7.188,0,0,0-2.15,5.656V500.6a3.56,3.56,0,0,0-3.329,3.547v4.807a4.234,4.234,0,0,0,4.229,4.229h9.752a4.234,4.234,0,0,0,4.229-4.229v-4.807A3.56,3.56,0,0,0,412.777,500.6Zm-8.5-7a4.758,4.758,0,0,1,4.958-.67,3.857,3.857,0,0,1,.735.479,4.352,4.352,0,0,1,1.439,3.48v3.7h-8.822v-2.35A5.9,5.9,0,0,1,404.28,493.6Zm10.462,15.35a2.867,2.867,0,0,1-2.864,2.864h-9.752a2.867,2.867,0,0,1-2.864-2.864v-4.807a2.2,2.2,0,0,1,2.193-2.193h10.226a.67.67,0,0,0,.829,0h.039a2.2,2.2,0,0,1,2.193,2.193Z"
                        transform="translate(567.584 -261.324)"
                        fill={
                          props.touched.password
                            ? props.errors.password
                              ? "#CC2626"
                              : "#26CC83"
                            : "#888891"
                        }
                      />
                    </g>
                  </svg>
                }
              />
              <FieldCustom
                type="password"
                name={"repassword"}
                placeHolder={"تکرار رمز عبور"}
                onChange={handleChange}
                onBlur={handleBlur}
                validate={value =>
                  validateRePassword(value, getFieldProps("password").value)
                }
                className={
                  touched.repassword
                    ? errors.repassword
                      ? "input-border-error"
                      : "input-border-green"
                    : "input-border-default"
                }
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.21"
                    height="22.029"
                    viewBox="0 0 18.21 22.029"
                  >
                    <g
                      id="password_icon"
                      data-name="password icon"
                      transform="translate(-965.481 -229.83)"
                    >
                      <path
                        id="Path_86"
                        data-name="Path 86"
                        d="M412.777,500.6v-3.731a5.807,5.807,0,0,0-1.932-4.505,5.2,5.2,0,0,0-1-.649,6.123,6.123,0,0,0-6.475.868,7.188,7.188,0,0,0-2.15,5.656V500.6a3.56,3.56,0,0,0-3.329,3.547v4.807a4.234,4.234,0,0,0,4.229,4.229h9.752a4.234,4.234,0,0,0,4.229-4.229v-4.807A3.56,3.56,0,0,0,412.777,500.6Zm-8.5-7a4.758,4.758,0,0,1,4.958-.67,3.857,3.857,0,0,1,.735.479,4.352,4.352,0,0,1,1.439,3.48v3.7h-8.822v-2.35A5.9,5.9,0,0,1,404.28,493.6Zm10.462,15.35a2.867,2.867,0,0,1-2.864,2.864h-9.752a2.867,2.867,0,0,1-2.864-2.864v-4.807a2.2,2.2,0,0,1,2.193-2.193h10.226a.67.67,0,0,0,.829,0h.039a2.2,2.2,0,0,1,2.193,2.193Z"
                        transform="translate(567.584 -261.324)"
                        fill={
                          props.touched.repassword
                            ? props.errors.repassword
                              ? "#CC2626"
                              : "#26CC83"
                            : "#888891"
                        }
                      />
                    </g>
                  </svg>
                }
              />
              {TextErrors(errors, touched)}
              {!!message && <ShowSuccess message={message} />}
              {error.type === "wrong" && error.message}

              <div className="d-flex justify-content-end mt-4">
                <Button
                  type="submit"
                  onClick={e => {
                    const { password } = values;
                    resetPassword(e, password);
                  }}
                  disabled={isSubmitting || !isValid}
                  className="submit-button "
                >
                  <Spinner
                    color="light"
                    size="sm"
                    className={!passwordReq.isLoading ? "d-none" : ""}
                  />{" "}
                  ارسال{" "}
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

const ResetPassword = props => {
  return (
    <div className="login-body-right">
      <div className="mx-auto">
        <a href="https://landin.ir">
          <img src={landinLogo} alt="لوگو" className="logo mb-5" />
        </a>
        <ResetPassFields {...props} />
      </div>
    </div>
  );
};

export default withRouter(ResetPassword);
